module.exports = __webpack_public_path__ + "img/wf-finishing-position-12.5abd8d66.svg";